var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "addadminmodal",
        width: "70%",
        minHeight: 300,
        minWidth: 200,
        maxWidth: 800,
        scrollable: true,
        adaptive: true,
        reset: true,
        height: "auto"
      },
      on: { "before-open": _vm.beforeOpen }
    },
    [
      _c("div", { staticClass: "modal--container" }, [
        _c("div", { staticClass: "d-flex justify-content-between pt-3" }, [
          _c("h4", [
            _vm._v(_vm._s(_vm.officeAdmin ? "Add Office Admin" : "Add Admin"))
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "close",
              attrs: { type: "button" },
              on: { click: _vm.closeModal }
            },
            [
              _c(
                "span",
                { attrs: { "aria-hidden": "true" } },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: "times", size: "1x" }
                  })
                ],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-column h-100" }, [
          _c("div", { staticClass: "row mt-4" }, [
            _c(
              "div",
              { staticClass: "col-12 col-md-5 form-group multi-container" },
              [
                _c("span", { staticClass: "cus-label" }, [
                  _vm._v("Select Employee")
                ]),
                _vm._v(" "),
                _c("multiselect", {
                  attrs: {
                    label: "name",
                    "track-by": "name",
                    placeholder: "Select Employee",
                    maxHeight: 150,
                    options: _vm.officeEmployees
                  },
                  on: { input: _vm.onChangeEmployee },
                  model: {
                    value: _vm.selected,
                    callback: function($$v) {
                      _vm.selected = $$v
                    },
                    expression: "selected"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          !_vm.officeAdmin && _vm.selected
            ? _c(
                "table",
                { staticClass: "table mt-4 table-bordered table-striped" },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v("Team")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Admin Access")])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.officeTeams.length > 0
                    ? _c(
                        "tbody",
                        _vm._l(_vm.officeTeams, function(team) {
                          return _c("tr", { key: team.id }, [
                            _c("td", { attrs: { width: "150" } }, [
                              _vm._v(_vm._s(team.attributes.name))
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: team.checked,
                                    expression: "team.checked"
                                  }
                                ],
                                staticClass: "cus-checkbox",
                                attrs: {
                                  id: "checkbox-" + team.id,
                                  type: "checkbox"
                                },
                                domProps: {
                                  value: team.checked,
                                  checked: Array.isArray(team.checked)
                                    ? _vm._i(team.checked, team.checked) > -1
                                    : team.checked
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.checkTeam(!team.checked, team.id)
                                  },
                                  change: function($event) {
                                    var $$a = team.checked,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = team.checked,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            team,
                                            "checked",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            team,
                                            "checked",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(team, "checked", $$c)
                                    }
                                  }
                                }
                              })
                            ])
                          ])
                        }),
                        0
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "error my-2" }, [
            _c("p", [_vm._v(_vm._s(this.error))])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "row justify-content-end align-items-end button-container"
            },
            [
              !_vm.officeAdmin
                ? _c(
                    "button",
                    {
                      staticClass: "save_btn hover-dark",
                      attrs: { type: "submit" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.assignToTeams.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("\n          Save Changes\n        ")]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "save_btn hover-dark",
                      attrs: { type: "submit" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.addOfficeAdmin.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("\n          Save Changes\n        ")]
                  )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-93b09bac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93b09bac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OfficeAdmin/Teams/AddAdminModal.vue
// module id = null
// module chunks = 